import React, { useState } from 'react';
import {
  useGetItemsQuery,
} from '../../../redux/vmsApi';
import {
  Box, Typography, TextField, Stack, Button, TableContainer,
  Paper, Table, TableHead, TableRow, TableCell, TableBody,
  Select, MenuItem, FormControl
} from '@mui/material';
import { camelCaseToSpaced } from '../../../utils/formattingUtil';

const ItemsListComponent: React.FC = () => {
  const [filters, setFilters] = useState({
    itemCode: '',
    description: '',
    inventoryCode: '',
    categoryCode: '',
    categoryDescription: '',
  });

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [apiParams, setApiParams] = useState({ ...filters, skip: 0, limit: 10 });

  const { data: items, isLoading, isError } = useGetItemsQuery(apiParams);

  const handleFilterChange = (field: string, value: string) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  const handleApplyFilters = () => {
    setApiParams({ ...filters, skip: 0, limit: pageSize });
    setPage(0);
  };

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
    setApiParams((prev) => ({ ...prev, skip: newPage * pageSize }));
  };

  const handlePageSizeChange = (event: any) => {
    const newSize = Number(event.target.value);
    setPageSize(newSize);
    setPage(0);
    setApiParams((prev) => ({ ...prev, limit: newSize, skip: 0 }));
  };

  if (isLoading) return <div>Loading...</div>;
  if (isError) return <div>Error fetching items.</div>;

  return (
    <React.Fragment>
      <Box sx={{ padding: 3, borderRadius: 2, marginBottom: 3, backgroundColor: '#f9f9f9', boxShadow: 3 }}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
          Items List
        </Typography>
        <Box display="flex" flexWrap="wrap" gap={2}>
          {['itemCode', 'description', 'inventoryCode', 'categoryCode', 'categoryDescription'].map((field) => (
            <TextField
              key={field}
              label={camelCaseToSpaced(field)}
              variant="outlined"
              size="small"
              value={(filters as any)[field]}
              onChange={(e) => handleFilterChange(field, e.target.value)}
              sx={{ maxWidth: 240, backgroundColor: '#fff', borderRadius: 1 }}
              fullWidth
            />
          ))}
        </Box>
        <Stack direction="row" spacing={2} mt={2}>
          <Button
            variant="outlined"
            size="large"
            onClick={handleApplyFilters}
            sx={{
              textTransform: 'none',
              fontWeight: 'bold',
              color: '#1976d2',
              borderColor: '#1976d2',
              '&:hover': { backgroundColor: '#e3f2fd', borderColor: '#1565c0' },
            }}
          >
            Apply Filters
          </Button>
        </Stack>
      </Box>

      <TableContainer component={Paper} sx={{ boxShadow: 3, borderRadius: 2 }}>
        <Table>
          <TableHead sx={{ backgroundColor: '#1976d2' }}>
            <TableRow>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Item Code</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Description</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Category</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Inventory</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Quantity Unit</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items && items.length > 0 ? (
              items.map((item: any, index: number) => (
                <TableRow key={item.id} sx={{ backgroundColor: index % 2 === 0 ? '#f0f4f7' : 'white' }}>
                  <TableCell>{item.itemCode}</TableCell>
                  <TableCell>{item.description}</TableCell>
                  <TableCell>{item.categoryCode},{item.categoryDescription}</TableCell>
                  <TableCell>{item.inventoryCode},{item.inventoryDescription}</TableCell>
                  <TableCell>{item.quantityUnit}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} align="center">No matching items found.</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Box display="flex" justifyContent="center" alignItems="center" mt={2}>
        <Button
          onClick={() => handlePageChange(Math.max(page - 1, 0))}
          disabled={page === 0}
          variant="contained"
          sx={{ marginRight: 2 }}
        >
          Previous
        </Button>

        <Typography variant="body1">Page {page + 1}</Typography>

        <Button
          onClick={() => handlePageChange(page + 1)}
          disabled={items?.length === undefined || items.length < pageSize}
          variant="contained"
          sx={{ marginLeft: 2 }}
        >
          Next
        </Button>
      </Box>

      <Box mt={2} display="flex" justifyContent="center" alignItems="center">
        <Typography variant="body2" sx={{ marginRight: 2 }}>Rows per page:</Typography>
        <FormControl variant="outlined" size="small">
          <Select
            value={pageSize}
            onChange={handlePageSizeChange}
            sx={{ backgroundColor: '#f0f4f7' }}
          >
            <MenuItem value={5}>5</MenuItem>
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={20}>20</MenuItem>
          </Select>
        </FormControl>
      </Box>
    </React.Fragment>
  );
};

export default ItemsListComponent;



  
   

